import { HelloWorld } from "HelloWorld/components"

export const App = () => (
  <HelloWorld />
)